import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { JwtService } from "src/app/shared/Services/jwt.service";
import { StorageService } from "src/app/shared/Services/storage.service";
import { UserType } from "src/app/shared/Constants/user-type";
import { SharedService } from "src/app/shared/Services/shared.service";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { FilterStateService } from "src/app/shared/Services/filter-state.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-sidebar-isdp',
  templateUrl: './sidebar-isdp.component.html',
  styleUrls: ['./sidebar-isdp.component.css']
})
export class SidebarIsdpComponent implements OnInit, OnDestroy {
  MenuIsdp = [
    {
      title: "Dashboard",
      name: "dashboard",
      permission: "Permissions.Dashboards.View",
      imageLink: "/../assets/images/dashboard.svg",
      routerLink: "/dashboard",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Unverified Suppliers",
      name: "Unverified Suppliers",
      permission: "Permissions.General.NonVerified",
      imageLink: "/../assets/images/icons/enterprises.svg",
      routerLink: "/supplier/list",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: false
    },
    {
      title: "Search Supplier",
      name: "Search Supplier",
      permission: "Permissions.General.Verified",
      imageLink: "/../assets/images/icons/job-seeker.svg",
      routerLink: "/supplier/search",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: false
    },
    {
      title: "Users",
      name: "users",
      permission: "Permissions.Users.View",
      imageLink: "/../assets/images/icons/interview.svg",
      routerLink: "/user/manage",
      resetpwdRouterLink: "/user/manage",
      IsClientIdReq: true
    },
    {
      title: "Reports",
      name: "reports",
      permission: "Permissions.Report.View",
      imageLink: "/../assets/images/invoice.png",
      routerLink: "/report/index",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: false
    },
    {
      title: "Invoices",
      name: "invoice",
      permission: "Permissions.Invoice.View",
      imageLink: "/../assets/images/invoice.png",
      routerLink: "/ep/enterprise/invoice",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: null
    }
  ];

  Permission: any = [];
  sidebarMenu: any;
  activeRoute: any;
  IsLogin: boolean = false;
  linkActive: any;
  status!: boolean;
  Utype: any;
  UserType: string = '';
  //#endregion
  @Input() open = new EventEmitter();
  selectedClientId!: any;
  constructor(
    private jwtService: JwtService,
    public storageService: StorageService,
    private sharedService: SharedService,
    private loggingService: LoggingService,
    private elementRef: ElementRef,
    private stateService: FilterStateService,
    private router: Router
    ) {
      this.sharedService.selectedClientId$.subscribe(clientId => {
        this.selectedClientId = clientId ?? localStorage.getItem('selectedClientId');
        if (this.selectedClientId > 0)
          this.setMenu();
        else if (this.selectedClientId == 0) {
          this.setMenu();
        }
      },
        err => { this.loggingService.captureException(err); }
      );
      this.IsLogin = this.storageService.isLoggedIn();

      this.Utype = UserType;
      if (this.IsLogin)
        this.setMenu();
    }

    ngDoCheck() {
      if (this.UserType == this.Utype?.Supplier) {
      this.setMenu()
      }
    }
    ngOnChanges(changes: SimpleChanges) {
      if ('selectedClientId' in changes) {
        const newJsId = changes['selectedClientId'].currentValue ?? 0;
        this.setMenu();
      }
    }
    // viewCardView() {
    //   localStorage.removeItem('supplierClientId')
    //   localStorage.removeItem('selectedClientName')
    //   this.isselectedSclientId = false;
    //   this.sharedService.setsupplierSelectedClientId(0);
    //   this.router.navigate(['/dashboard']);

    // }
    setMenu() {
      this.UserType = this.jwtService.getUserType();
      this.Permission = this.jwtService.getPermissions();
      if (this.UserType == this.Utype?.Admin) {
        if (this.selectedClientId == null) {
          this.sidebarMenu = this.MenuIsdp.filter((item1) =>
            this.Permission.some((item2: string) => item1.permission === item2 && !item1.IsClientIdReq && item1.IsClientIdReq != null))
        }
      }
      else {
        if (this.Permission != null && this.MenuIsdp != null) {
          this.sidebarMenu = this.MenuIsdp.filter((item1) =>
            this.Permission.some((item2: string) => item1.permission === item2 && item1.IsClientIdReq != null));
        }
      }

      if (this.selectedClientId > 0) {
        this.sidebarMenu = this.MenuIsdp.filter((item1) =>
          this.Permission.some((item2: string) => item1.permission === item2 && item1.IsClientIdReq && item1.IsClientIdReq != null))
      }
      else if (this.selectedClientId == 0) {
        this.sidebarMenu = this.MenuIsdp.filter((item1) =>
          this.Permission.some((item2: string) => item1.permission === item2 && !item1.IsClientIdReq && item1.IsClientIdReq != null))
      }
      if (this.sidebarMenu != null) {
        const dashboardMenuItem = this.MenuIsdp.find(item => item.name === 'dashboard');
        if (dashboardMenuItem && !this.sidebarMenu.some((item: { name: string; }) => item.name === 'dashboard')) {
          this.sidebarMenu.unshift(dashboardMenuItem);
        }
      }
      if (this.sidebarMenu != null) {
        const usersMenuItem = this.MenuIsdp.find(item => item.name === 'users');
        if (usersMenuItem && this.UserType !== this.Utype?.JobSeeker && (!this.sidebarMenu.some((item: { name: string; }) => item.name === 'users'))) {
          this.sidebarMenu.push(usersMenuItem);
        }
      }
      if (this.UserType == this.Utype?.Supplier) {
        if (this.sidebarMenu != null) {
          this.sidebarMenu.forEach((element: any, index: number) => {
            if ((element.name == "epJobs" || element.name=="Jobseeker") && localStorage.getItem('issupplierMultipleClient') && (!localStorage.getItem('supplierClientId'))) {
              this.sidebarMenu.splice(index, 1);
            }
          });
        }
      }
    }
    ngOnInit() {
      this.UserType = this.jwtService.getUserType();
      const jobRequestMenu = this.MenuIsdp.find(menuItem => menuItem.name === "epJobs");
      if (jobRequestMenu) {
        jobRequestMenu.routerLink =
          this.UserType === this.Utype.JobSeeker
            ? "/jobrequest/jsindex"
            : "/jobrequest/index";
      }
    }

    ngOnDestroy() { }

    //  New changes
    activeLinks(val: any) {
      this.linkActive = val;
      this.stateService.resetAllFilterState();
    }

    openMenu() {
      this.status = !this.status;
      var element = document.getElementById("accordionSidebar");
      var element2 = document.getElementById("mainwrapper");
      if (this.status) {
        element?.classList.remove("toggled");
        element2?.classList.remove("closemenu");
      } else {
        element?.classList.add("toggled");
        element2?.classList.add("closemenu");
      }
    }

    @HostListener('document:click', ['$event'])
    onClick(event: Event) {
      if (this.status && !this.elementRef.nativeElement.contains(event.target)) {
        this.closeMenu();
      }
    }

    closeMenu() {
      this.status = false;
      var element = document.getElementById("accordionSidebar");
      var element2 = document.getElementById("mainwrapper");
      element?.classList.add("toggled");
      element2?.classList.add("closemenu");
    }
}
